import { Outlet } from 'react-router-dom';
import * as R from 'ramda';

import { useNavigation } from '@atom/hooks/useNavigation';

import ChatSidebar from '../components/chat/ChatSidebar';

import TopNavigationBar from './common/navigation/TopNavigationBar';

const SKIP_TOP_BAR_URLS = [
  '/no-permission',
  '/not-found',
  '/unknown-error',
  '/inventory/MUTCD',
];

const PDF_URL_SEGMENT_WHITELIST = [
  'collinsMpcPdfReport',
  'idlPdfReport',
  'scdotPdfReport',
  'workPdfReport',
  'odotPdfReport',
  'aldotPdfReport',
  'gwrrPdfReport',
];

const Layout = () => {
  const [, { pathname }] = useNavigation();
  const paths = pathname?.split('/');
  const isPdfUrl =
    paths?.includes('workOrder') &&
    !R.isEmpty(R.intersection(paths, PDF_URL_SEGMENT_WHITELIST));

  const includeTopBar = !isPdfUrl && !SKIP_TOP_BAR_URLS.includes(pathname);

  return (
    <>
      <div style={{ height: '100%' }}>
        {includeTopBar && <TopNavigationBar />}
        <Outlet />
      </div>
      <ChatSidebar />
    </>
  );
};

export default Layout;
